import http from "utils/http";
import { predictiveMaintenance } from "constants/endpoints";

const deleteMachineById = ({ machineId }) => {
  const ENDPOINT = predictiveMaintenance.deleteMachineById({
    machineId,
  });
  const { REACT_APP_API_BASE_URL: API_BASE_URL } = process.env;
  return http.delete(`${API_BASE_URL}${ENDPOINT}`);
};

export default deleteMachineById;
